import React from 'react';

function KpiCard({ title, value, tone = 'slate' }) {
  const tones = {
    slate: 'border-slate-200 dark:border-slate-800 bg-white dark:bg-[#101922]',
    green: 'border-green-200 dark:border-green-900/30 bg-green-50 dark:bg-green-900/10',
    amber: 'border-amber-200 dark:border-amber-900/30 bg-amber-50 dark:bg-amber-900/10',
    red: 'border-red-200 dark:border-red-900/30 bg-red-50 dark:bg-red-900/10',
    blue: 'border-sky-200 dark:border-sky-900/30 bg-sky-50 dark:bg-sky-900/10'
  };

  return (
    <div className={`rounded-xl border p-5 shadow-sm ${tones[tone] || tones.slate}`}>
      <div className="text-sm font-medium text-slate-500 dark:text-slate-400">{title}</div>
      <div className="mt-2 text-2xl font-bold text-slate-900 dark:text-white">{value}</div>
    </div>
  );
}

export default function ProfessionalKpiCards({
  metrics,
  loading = false,
  error = null,
  onRefresh = null,
  compact = false,
  hideHeader = false
}) {
  return (
    <div className="bg-white dark:bg-[#101922] p-6 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm">
      {!hideHeader ? (
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-slate-900 dark:text-white text-base font-semibold">Uzman Ozeti</h3>
          <div className="flex items-center gap-3">
            <span className="text-xs text-slate-500 dark:text-slate-400">Son 30 gun / Son 7 gun</span>
            {onRefresh ? (
              <button
                onClick={onRefresh}
                disabled={loading}
                className="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                {loading ? 'Yenileniyor...' : 'Yenile'}
              </button>
            ) : null}
          </div>
        </div>
      ) : null}

      {error ? (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900/30 dark:bg-red-900/10 dark:text-red-300">
          {error}
        </div>
      ) : null}

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <KpiCard title="Aktivasyon Oranı" value={`${metrics?.activation?.activationRate ?? '...'}%`} tone="blue" />
        <KpiCard title="Son 7 Gunde Aktif Uzman" value={metrics?.retention?.d7ActiveProfessionals ?? '...'} tone="green" />
        <KpiCard title="Free -> Pro Oranı" value={`${metrics?.revenue?.freeToProRate ?? '...'}%`} tone="amber" />
        <KpiCard title="Aktif İlişki" value={metrics?.operations?.activeRelationshipCount ?? '...'} />
      </div>

      {!compact ? (
        <>
          <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            <KpiCard title="Onboarding Başlayan" value={metrics?.activation?.onboardingStartedCount ?? '...'} />
            <KpiCard title="İlk Danışan Oluşan" value={metrics?.activation?.firstClientCount ?? '...'} />
            <KpiCard title="Paywall Vuruşu" value={metrics?.revenue?.paywallHits ?? '...'} />
            <KpiCard title="Abonelik Aktifleşen" value={metrics?.revenue?.subscriptionActivatedCount ?? '...'} />
          </div>

          <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-xs text-slate-600 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-300">
            Davet başarı oranı: <span className="font-bold">{metrics?.operations?.inviteSuccessRate ?? '...'}%</span>
            {' • '}
            Davet adedi: <span className="font-bold">{metrics?.operations?.inviteSentCount ?? '...'}</span>
            {' • '}
            Rıza kabul adedi: <span className="font-bold">{metrics?.operations?.consentAcceptedCount ?? '...'}</span>
          </div>
        </>
      ) : null}
    </div>
  );
}

